import {
  VERTICAL_CARD_INFO_INDENT,
  VERTICAL_CARD_RATIO,
  VERTICAL_CARD_SIZE,
} from '../../../constants'
import {
  createSkeletonSlots,
  shouldShowPrizeModalProducts,
} from '../../../utils/prize-modal-products'
import { GaProductCardVertical } from '../product-card-vertical'

// @vue/component
export default {
  name: 'ga-product-list',

  components: {
    GaProductCardVertical,
  },

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    productsLink: {
      type: String,
      default: '',
    },
    shouldEnrichProducts: {
      type: Boolean,
      default: false,
    },
  },

  async setup(props) {
    const { products, productsLink, shouldEnrichProducts } = toRefs(props)
    const { $gaApp } = useNuxtApp()

    const displaySlots = ref(createSkeletonSlots())

    const getProductCardProps = (index) => ({
      maxCountMedia: 1,
      size: VERTICAL_CARD_SIZE.M,
      ratio: VERTICAL_CARD_RATIO.SQUARE,
      infoIndent:
        index % 2 === 0
          ? VERTICAL_CARD_INFO_INDENT.START
          : VERTICAL_CARD_INFO_INDENT.END,
    })

    const loadPrizeProducts = async () => {
      if (
        !shouldShowPrizeModalProducts({
          products: products.value,
          productsLink: productsLink.value,
          shouldEnrichProducts: shouldEnrichProducts.value,
        })
      ) {
        displaySlots.value = []
        return
      }

      displaySlots.value = createSkeletonSlots()

      const slots = await $gaApp.services.product.main.loadPrizeModalProducts({
        products: products.value,
        productsLink: productsLink.value,
        shouldEnrichProducts: shouldEnrichProducts.value,
      })

      if (slots !== null) {
        displaySlots.value = slots
      }
    }

    watch(
      [products, productsLink, shouldEnrichProducts],
      () => {
        loadPrizeProducts()
      },
      { immediate: true },
    )

    onUnmounted(() => {
      $gaApp.services.product.main.abortPrizeModalProductsLoad()
    })

    return {
      displaySlots,
      getProductCardProps,
    }
  },
}
